/* eslint-disable max-len */
/* eslint-disable no-restricted-imports */
import {
  Avatar,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Typography,
} from '@material-ui/core';
import { Close as CloseIcon, Code as CodeIcon, WhatsApp as WhatsAppIcon } from '@material-ui/icons';

import { extractVariables } from '../utils/extractVariables';

export function PreviewDialog({ isOpen, handleClose, previewContent }) {
  const variables = extractVariables(previewContent);

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth='md'
      fullWidth
      PaperProps={{
        style: {
          borderRadius: 16,
          minHeight: '400px',
        },
      }}
    >
      <DialogTitle style={{ paddingBottom: 8 }}>
        <Box display='flex' alignItems='center'>
          <Avatar style={{ backgroundColor: '#25D366', marginRight: 16 }}>
            <WhatsAppIcon />
          </Avatar>
          <Box>
            <Typography variant='h6' style={{ fontWeight: 'bold' }}>
              Preview da Mensagem
            </Typography>
            <Typography variant='body2' color='textSecondary'>
              Visualize como a mensagem aparecerá no WhatsApp
            </Typography>
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent>
        {/* Simulação do WhatsApp */}
        <Paper
          elevation={0}
          style={{
            backgroundColor: '#e3f2fd',
            padding: 24,
            borderRadius: 16,
            marginBottom: 24,
            minHeight: 200,
            backgroundImage:
              'url("data:image/svg+xml,%3Csvg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="%23f5f5f5" fill-opacity="0.1" fill-rule="evenodd"%3E%3Cpath d="m0 40l40-40h-40v40z"/%3E%3C/g%3E%3C/svg%3E")',
          }}
        >
          <Box
            style={{
              backgroundColor: '#dcf8c6',
              padding: 16,
              borderRadius: '18px 18px 4px 18px',
              maxWidth: '80%',
              marginLeft: 'auto',
              boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
            }}
          >
            <Typography
              variant='body1'
              style={{
                fontSize: 14,
                lineHeight: 1.5,
                whiteSpace: 'pre-wrap',
                fontFamily: 'system-ui, -apple-system, sans-serif',
              }}
            >
              {previewContent}
            </Typography>
            <Typography
              variant='caption'
              style={{
                color: '#667781',
                display: 'block',
                textAlign: 'right',
                marginTop: 8,
                fontSize: 11,
              }}
            >
              {new Date().toLocaleTimeString('pt-BR', {
                hour: '2-digit',
                minute: '2-digit',
              })}{' '}
              ✓✓
            </Typography>
          </Box>
        </Paper>

        {/* Informações sobre variáveis */}
        {variables.length > 0 && (
          <Box>
            <Typography
              variant='subtitle2'
              gutterBottom
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <CodeIcon style={{ marginRight: 8, fontSize: 18 }} />
              Variáveis Detectadas ({variables.length})
            </Typography>
            <Box display='flex' flexWrap='wrap' gap={1}>
              {variables.map((variable, index) => (
                <Chip
                  key={index}
                  label={variable}
                  size='small'
                  color='primary'
                  variant='outlined'
                  icon={<CodeIcon />}
                />
              ))}
            </Box>
          </Box>
        )}

        {/* Estatísticas da mensagem */}
        <Box
          display='flex'
          justifyContent='space-around'
          style={{
            marginTop: 24,
            padding: 16,
            backgroundColor: '#f8f9fa',
            borderRadius: 8,
          }}
        >
          <Box textAlign='center'>
            <Typography variant='h6' style={{ fontWeight: 'bold', color: '#1976d2' }}>
              {previewContent.length}
            </Typography>
            <Typography variant='caption' color='textSecondary'>
              Caracteres
            </Typography>
          </Box>
          <Box textAlign='center'>
            <Typography variant='h6' style={{ fontWeight: 'bold', color: '#1976d2' }}>
              {previewContent.split(/\s+/).length}
            </Typography>
            <Typography variant='caption' color='textSecondary'>
              Palavras
            </Typography>
          </Box>
          <Box textAlign='center'>
            <Typography variant='h6' style={{ fontWeight: 'bold', color: '#1976d2' }}>
              {variables.length}
            </Typography>
            <Typography variant='caption' color='textSecondary'>
              Variáveis
            </Typography>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions style={{ padding: '16px 24px' }}>
        <Button
          onClick={handleClose}
          variant='contained'
          color='primary'
          startIcon={<CloseIcon />}
          style={{ borderRadius: 25 }}
        >
          Fechar Preview
        </Button>
      </DialogActions>
    </Dialog>
  );
}
